import React, { Component, Fragment } from 'react';
import DetalleATiempoSuc from './detalleTiempoSuc.jsx';

class tabDetalle extends Component {

    render() {
        const { Datos, listTiempos, sucTiempo } = this.props;

        return (
            <Fragment>
                <div className="row">
                    <div className="col">
                        <h4 className="consultas-ord">Cliente</h4>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <label>{Datos.Codigo.attributes.label}</label>
                        <p>{Datos.Codigo.value}</p>
                    </div>
                    <div className="col">
                        <label>{Datos.NitIde.attributes.label}</label>
                        <p>{Datos.NitIde.value}</p>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <label>{Datos.Nombre.attributes.label}</label>
                        <p>{Datos.Nombre.value}</p>
                    </div>
                    <div className="col">
                        <label>{Datos.Email.attributes.label}</label>
                        <p>{Datos.Email.value}</p>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <label>{Datos.Entregar.attributes.label}</label>
                        <p>{Datos.Entregar.value}</p>
                    </div>

                </div>
                <div className='row'>
                    <div className="col">
                        <h4 className="consultas-ord">Tiempos</h4>
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th>Sitio</th>
                                    <th>Entró</th>
                                    <th>Salió</th>
                                    <th>Duración</th>
                                    <th>Designado</th>
                                    <th>Retraso</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    sucTiempo.map(suc => {
                                        return (
                                            <DetalleATiempoSuc listTiempos={listTiempos} suc={suc} />
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </Fragment>
        )
    }
};

export default tabDetalle;